import PostOfUser from "./postOfUser";
export default PostOfUser;